import React, { useState, useEffect } from "react";
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";
import '../Css/App.css'
import '../Css/index.css'
import { useHistory } from "react-router";


const PaginaCortesiaVpn: React.FC = (props) => {

    const { instance } = useMsal();
    const history = useHistory();
    const errorObj: any = history.location.state;
    const errorMsg: string = errorObj.message;
    const errorStack: string = errorObj.stack;

    return (
        <div className="vh-100 vw-100 bg-white row mx-0 regular d-flex justify-content-center align-items-center text-center align-content-start" style={{ position: "fixed", top: 0, left: 0, zIndex: 10000 }}>
            <div>
                <h1 className="w-100 mt-5">Oops!</h1>
                <h3 className="w-100 mt-2">We are sorry but to access the application you must be logged in to the Luxottica VPN, <br /> please contact the administrator</h3>
                <div className="text-left col-12 row mx-0">
                    <h5>{errorMsg}</h5>
                    <span style={{ fontSize: "0.7em" }}>{errorStack}</span>
                </div>
                {/* <button type="button" className="w-100 d-flex flex-column align-items-center btn btn-link no-deco hoverBack mt-3" onClick={() => instance.logoutPopup({ postLogoutRedirectUri: "/", mainWindowRedirectUri: "/" })}>
                    <img width="30" src={require('../svg/Icons-Navigation-Logout.svg')}></img>
                    <span className="regular">Logout</span>
                </button> */}
            </div>
        </div>
    )
}

export default PaginaCortesiaVpn